"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addToCart as addProductToCart } from "@/lib/centra/selectionFunctions";
import { setCartItemQuantity } from "@/lib/centra/selectionFunctions";
import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";
import type { CartItem } from "./useItems";

export const useChangeSize = () => {
  const queryClient = useQueryClient();
  const customerToken = usePersistedStore((state) => state.token);

  const changeSize = useMutation({
    mutationFn: async ({
      item,
      newSizeItemId,
    }: {
      item: CartItem;
      newSizeItemId: string;
    }) => {
      const originalQuantity = item.quantity || 1;

      // Step 1: Remove the old size by setting quantity to 0
      await setCartItemQuantity(
        { line: item.id, newQuantity: 0 },
        customerToken
      );

      // Step 2: Add the new size with quantity 1 first
      const result = await addProductToCart(
        {
          itemId: newSizeItemId,
        },
        customerToken
      );

      // Step 3: If original quantity was more than 1, update the quantity
      if (originalQuantity > 1) {
        // Find the line ID of the newly added item
        const newItem = result.selection?.items?.find(
          (i: any) => i.itemId === newSizeItemId
        );

        if (newItem?.line) {
          await setCartItemQuantity(
            { line: newItem.line, newQuantity: originalQuantity },
            customerToken
          );
        }
      }

      return result;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["selection"] });
    },
  });

  return { changeSize };
};
